module.exports = __webpack_public_path__ + "images/6a567db122eeec52a73b67c668944672.png";